import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueStore from './components/store'
import './registerServiceWorker'
import M from './components/plugins/Materialize'
import $ from './components/plugins/jQuery'
import firebase from './components/plugins/Firebase'
// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// library.add(faUserSecret)
/**
 * @module vue/main
 * @desc See {@link https://vuejs.org/v2/guide/} <br>Main VueJS App Entry Point
 * Wait for Firebase SDK to load then fetch user if logged-in
 * @requires Vue
 * @requires Materialize
 * @requires jQuery
 * @requires Firebase
*/
// Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
Vue.use(M)
Vue.use($)
Vue.use(firebase)

firebase.fetchUser().then(user=>{
  new Vue({
    router,
    store: VueStore,
    render: h => h(App),
    beforeCreate() {
      VueStore.commit('set',{store:'user',data:user});
      this.$firebase.auth().onAuthStateChanged(()=>{
        VueStore.dispatch('refreshUser');
      })
    },
  }).$mount('#app')
})